import React, { useState } from "react"
import PageHeaders from "../common/PageHeaders"
import Menu from "../common/Menu"
import Header from "../components/Header"
import Footer from "../components/Footer"

const About = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <>
      <PageHeaders type="legal"/>
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${!!menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={state => {
              setMenuOpen(state.isOpen)
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="topSection texture-bkg" id="page-wrap">
          <div className="headerBar">
            <Header siteTitle={"Legal"} />
          </div>
          <div className="flex mt-32 lg:mt-24">
            <main className="w-full text-dark pt-10">
                      <section className="mb-20 px-10 max-w-page">
                        <h1 className="text-3xl md:text-5xl  font-bold text-center w-10/12 mx-auto">
                          Legal
                        </h1>
                      </section>
                    <section className="w-full bg-white px-10 md:px-20 py-10">
                      <div className="max-w-page">
                      <section>
                      <p>
                        Thank you for choosing to be part of our community at
                        TomoCredit Inc (<b>“TomoCredit”</b>, <b>“we”</b>,{" "}
                        <b>“us”</b>, or <b>“our”</b>). We are committed to
                        protecting your personal information and your right to
                        privacy. If you have any questions or concerns about our
                        policy, or our practices with regards to your personal
                        information, please contact us at help@tomocredit.com.
                      </p>
                      <p>
                        We use various third-party services to help bring our
                        product to you. As you use this site and/or our
                        services, you will be informed of any terms that apply.
                        When applying to one of our loan products, you may be
                        requested to give consent to the use of your
                        information, or be required to accept certain terms and
                        conditions.
                      </p>
                      <p>
                        All disclosures, privacy policies, terms of use,
                        legal agreements, etc are accessible here for your
                        reference.
                      </p>
                    </section>

                    <section className="mt-5">
                      <h3 className="font-bold  text-xl mb-2"> OUR TERMS OF USE</h3>

                      <p>
                        Our Privacy Policy and Terms of Use will{" "}
                        <em>always</em> be available for you to review on our
                        homepage,{" "}
                        <a href="https://tomocredit.com/">
                          https://tomocredit.com/
                        </a>
                        . You will find links at the bottom of our homepage.
                      </p>

                      <p>
                        <ul>
                          <li>
                            TomoCredit Privacy Policy:{" "}
                            <a href="https://tomocredit.com/privacypolicy">
                              https://tomocredit.com/privacypolicy
                            </a>
                          </li>
                          <li>
                            TomoCredit Terms of Use:{" "}
                            <a href="https://tomo-public-docs.s3.us-west-1.amazonaws.com/TermsOfUse.pdf">
                            https://tomo-public-docs.s3.us-west-1.amazonaws.com/TermsOfUse.pdf
                            </a>
                          </li>
                        </ul>
                      </p>
                    </section>
                    
                    <section className="mt-5">
                      <h3 className="font-bold  text-xl mb-2"> TWILIO, INC</h3>

                      <p>
                        We use Twilio, Inc to allow text communications with our
                        customers. In particular, we employ the use of Twilio's
                        services to send verification codes to help verify
                        identity and deter fraud.
                      </p>

                      <p>
                        You do not have to agree to these terms, but they may be
                        helpful for you to review. You may find their Privacy
                        Policy and their Terms of Use here:
                      </p>
                      <p>
                        <ul>
                          <li>
                            Twilio's Privacy Policy:{" "}
                            <a href="https://www.twilio.com/legal/privacy#how-twilio-processes-your-end-users-personal-information">
                              https://www.twilio.com/legal/privacy#how-twilio-processes-your-end-users-personal-information
                            </a>
                          </li>
                          <li>
                            Twilio's Terms of Service:{" "}
                            <a href="https://www.twilio.com/legal/tos#4-customer-data">
                              https://www.twilio.com/legal/tos#4-customer-data
                            </a>
                          </li>
                        </ul>
                      </p>
                    </section>

                    <section className="mt-5">
                      <h3 className="font-bold  text-xl mb-2"> QUESTIONS?</h3>

                      <p>
                        If you have questions or comments about our legal terms,
                        you may email us at help@tomocredit.com or by post to:
                      </p>

                      <p>
                      TomoCredit Inc
                        <br />
                        PO BOX 194807
                        <br />
                        San Francisco, CA 94119 United States
                      </p>
                    </section>
                      </div>
                    </section>
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default About
